import { Body } from "@hypercard/web-components";
import {
  ExpenseReportStatus,
  ExpenseStatus,
  StipendExpenseStatus,
} from "@common/utils/graphql";
import { cn, getColorClassForState } from "@/utils/utils";

type Props = {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  status: ExpenseStatus | ExpenseReportStatus | StipendExpenseStatus;
  displayStatus?: string;
  isAutoApproved?: boolean;
};

export const StatusText = ({
  status,
  displayStatus = status,
  size = "md",
  isAutoApproved = false,
}: Props) => (
  <Body
    size={size}
    weight="regular"
    className={cn("capitalize", getColorClassForState(status))}
  >
    {isAutoApproved ? "Auto-Approved" : displayStatus}
  </Body>
);
